import { useEffect } from 'react';

export const useUpdateBodyBackground = (color: string) => {
	useEffect(() => {
		const originalBackgroundColor = document.body.style.backgroundColor;

		document.body.style.backgroundColor = color;

		return () => {
			document.body.style.backgroundColor = originalBackgroundColor;
		};
	}, [color]);
};
